// extracted by mini-css-extract-plugin
export var container = "_86-0";
export var icon = "_86-1";
export var text = "_86-2";